import FanPassClaim from './fan-pass-claim'

export * from './fan-pass-claim'

FanPassClaim.define('fp-claim')

declare global {
  interface HTMLElementTagNameMap {
    'fp-claim': FanPassClaim;
  }
}
export default FanPassClaim